import { render, staticRenderFns } from "./compliance-tab.vue?vue&type=template&id=28d151e6"
import script from "./compliance-tab.vue?vue&type=script&lang=js"
export * from "./compliance-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports